'use client';

import CmsBlockGroup from '@/components/CmsBlock';
import { websiteEnv } from '@/constants/website-env';
import classes from './shippingPolicyPage.module.css';

export const ShippingPolicyPage = () => {
  const pageTitle = 'SHIPPING POLICY';

  return (
    <div className={classes.shippingpolicy}>
      <h1 className={classes.title}>{pageTitle}</h1>
      <CmsBlockGroup
        classes={{
          root: classes.con,
        }}
        identifiers={
          websiteEnv.isUnitedStates ? 'shipping-policy' : `shipping-policy-${process.env.NEXT_PUBLIC_STORE_VIEW_CODE}`
        }
        resolveRelativePath={!!process.env.NEXT_PUBLIC_BASE_PATH}
      />
    </div>
  );
};

export default ShippingPolicyPage;
